import { render, staticRenderFns } from "./ServiceDetailView.vue?vue&type=template&id=7400ffb3&scoped=true&lang=pug&"
import script from "./ServiceDetailView.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailView.vue?vue&type=style&index=0&id=7400ffb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7400ffb3",
  null
  
)

export default component.exports